<div class="component"
     #scroll>
    <span class="empty"
          [hidden]="!(emptyMessage)"
          [textContent]="emptyMessage">
    </span>
    <div [hidden]="!amounts || !!emptyMessage || amounts.length === 0"
         class="tableWrapper">
        <div class="repeater-container">
            <table>
                <tbody>
                <tr *ngFor="let item of amounts"
                    data-automation-e2e-selector="top_managers_accounts_table_row"
                    [attr.data-automation-e2e-item-id]="item.id">
                    <td title="{{item.name}}"
                        data-automation-e2e-selector="account">
                        <muni-gameday-profile-overview-open-link [text]="item.name"
                                                        [linkType]="item.type"
                                                        [cropped]="false">
                        </muni-gameday-profile-overview-open-link>
                    </td>
                    <td title="{{item.amountFormatted}}"
                        [textContent]="item.amountFormatted"
                        data-automation-e2e-selector="amount">
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
